// extracted by mini-css-extract-plugin
module.exports = {"blogNavigation":"Navigation_blogNavigation__fXo4a","next":"Navigation_next__RLTi4","previous":"Navigation_previous__EG4SX"};